// extracted by mini-css-extract-plugin
module.exports = {"title":"AddEntityModal_title__3aOiJ","dialog":"AddEntityModal_dialog__3RDh_","warning":"AddEntityModal_warning__1YX68","editIcon":"AddEntityModal_editIcon__18Wa0"};